var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"mb-1 pa-0 pl-4",attrs:{"to":{ path: _vm.route, params: _vm.params },"target":_vm.inNewCard ? '_blank' : '_top'}},[_c('v-list-item-action',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.title))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }